import BackboneElement from './BackboneElement';
import CodeableConcept from './types/CodeableConcept';
import Reference from './types/Reference';

import merge from 'lodash/merge';

export default class ClaimPayee extends BackboneElement {
    static __className = 'ClaimPayee';

    __objectStructure = {
        type: CodeableConcept,
        party: Reference,
    };

    constructor(constructJson, className = 'ClaimPayee') {
        super(constructJson, className);

        this.createAndPopulateStructure(this.__objectStructure, constructJson);
        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
